import Angular from "angular";

let DisableScrollOnSwipeModule = Angular.module('disable-scroll-on-swipe', []);

DisableScrollOnSwipeModule.directive('disableScrollOnSwipe', function ($ionicScrollDelegate) {
    return {
        restrict: 'EA',
        link: function (scope, element) {
            var startX, startY, isDown = false;

            element.bind("mousedown touchstart", function (e) {
                e = (e.touches) ? e.touches[0] : e; //e.touches[0] is for ios
                startX = e.clientX;
                startY = e.clientY;
                isDown = true;
            });

            element.bind("mousemove touchmove", function (e) {
                e = (e.touches) ? e.touches[0] : e; //e.touches[0] is for ios
                if (isDown) {
                    var deltaX = Math.abs(e.clientX - startX);
                    var deltaY = Math.abs(e.clientY - startY);
                    var isSwipeHorizontal = deltaX > deltaY;

                    if (isSwipeHorizontal) {
                        $ionicScrollDelegate.freezeScroll(true);
                    }
                }
            });

            element.bind("mouseup touchend", function (e) {
                isDown = false;
                $ionicScrollDelegate.freezeScroll(false);
            });
        }
    }
});

export default DisableScrollOnSwipeModule;



// WEBPACK FOOTER //
// ./src/modules/core/directives/disable-scroll-on-swipe.js